import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  const { pathname } = location;

  return (
    <>
        <footer>
            <div class="container">
            <div className="foot-box-n">
              <div class="row">
                
                <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <div class="foot">
                    <h4>Support</h4>
                    <ul>
                      <li><a href="#">Help Center</a></li>
                      <li><a href="#">VerifiedCover</a></li>
                      <li><a href="#">Verify Your Profile</a></li>
                      <li><a href="#">Anti Discrimination</a></li>
                      <li><a href="#">Disability Support</a></li>
                      <li><a href="#">Cancellation Options</a></li>
                      <li><a href="#">Report Neighbourhood Concern</a></li>
                    </ul>
                  </div>
                </div>
                <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <div class="foot">
                    <h4>Listing</h4>
                    <ul>
                      <Link to="/list-new"><li>Verify Your Property</li></Link>
                      <Link to="/property-new"><li>VerifiedCover for your Property</li></Link>
                      <li><a href="#">Listing Resources</a></li>
                      <li><a href="#">Community Forum</a></li>
                      <li><a href="#">Listing Responsibly</a></li>
                      <li><a href="#">Listing Class</a></li>
                      <li><a href="#">Find a Broker</a></li>
                    </ul>
                  </div>
                </div>
                <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <div class="foot">
                    <h4>Verified Properties</h4>
                    <ul>
                      <li><a href="#">News Room</a></li>
                      <li><a href="#">New Features</a></li>
                      <li><a href="#">Careers</a></li>
                      <li><a href="#">Investors</a></li>
                      <li><a href="#">Verified Properties Contact Center</a></li>
                      <li><a href="#">Verified Properties Brand Resources</a></li>
                      <li><a href="#">About Verified Properties</a></li>
                    </ul>
                  </div>
                </div>
              </div>
             
              
              </div>
              <div class="row">
                <div class="copyright d-flex flex-wrap">
                  
                  <div className="col-md-6 policy-text"> <span>© 2025 Verified Properties </span> <Link to="/privacy-policy" className={pathname === '/privacy-policy' ? 'active' : ''}>Privacy Policy</Link> <Link to="/term-services" className={pathname === '/term-services' ? 'active' : ''}>Terms of Service</Link></div>
                  <div className="col-md-6 text-end"><span className="float-right">Emirates Ventures</span></div>
                  </div>
                  
                
                  </div>
            </div>
        </footer>
    </>
  );
}

export default Footer;